import { FaGithub, FaLinkedin, FaTelegram, FaWhatsapp, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  const year = new Date().getFullYear();

  const links = [
    { icon: <FaGithub className="w-4 h-4" />, href: "https://github.com/MickeyDagm", label: "GitHub" },
    { icon: <FaLinkedin className="w-4 h-4" />, href: "https://www.linkedin.com/in/dagmawi-ephrem-559a7b342", label: "LinkedIn" },
    { icon: <FaTelegram className="w-4 h-4" />, href: "https://t.me/dagi_0056", label: "Telegram" },
    { icon: <FaWhatsapp className="w-4 h-4" />, href: "https://wa.me/qr/VPX75GG4PGCCP1", label: "WhatsApp" },
    { icon: <FaInstagram className="w-4 h-4" />, href: "https://www.instagram.com/mickey_dagm/profilecard/?igsh=MW4xeTRwM3YxdWtzMw==", label: "Instagram" },
  ];

  return (
    <footer className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <a href="#home" className="text-xl font-bold tracking-tight">
              <span className="text-white">Dagmawi</span>
              <span className="gradient-text">.dev</span>
            </a>
            <p className="text-sm text-gray-500 mt-1">
              Building the future, one commit at a time.
            </p>
          </div>

          <div className="flex items-center gap-3">
            {links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noreferrer"
                className="p-2.5 glass rounded-xl text-gray-500 hover:text-primary-400 hover:border-primary-500/30 transition-all"
                aria-label={link.label}
              >
                {link.icon}
              </a>
            ))}
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-white/5 text-center text-sm text-gray-600">
          <p>© {year} Dagmawi Ephrem. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
